/* eslint-disable */
import dayjs from 'dayjs'
import sensors from '../utils/sensors'
import CONFIG from '../constants/config'
import fetchHelper from '../utils/fetchHelper'
import * as MapUtils from '../utils/mapUtils'
import exceptionHelper from '../utils/exceptionHelper'
import { captureFetchException } from '../utils/sentryUtils'
import {
  setDate as setDateAction,
  setPathways as setPathwaysAction,
  setMembers as setMembersAction,
  setCheckedMembers as setCheckedMembersAction,
  setCurrentUser as setCurrentUserAction,
  setViewerPhotos as setViewerPhotosAction,
  setUserListPanel as setUserListPanelAction
} from '../slices/pathwaySlice'

// 重导出 slice actions，保持 API 兼容
export function setDate(data) {
  return setDateAction(data)
}

export function setPathways(data) {
  return setPathwaysAction(data)
}

export function setCurrentUser(data) {
  return setCurrentUserAction(data)
}

export function setCheckedMembers(data) {
  return setCheckedMembersAction(data)
}

export function setUserListPanel(data) {
  return setUserListPanelAction(data)
}

export function fetchMembers(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/photoroute/persons',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .then((data) => {
        dispatch(setMembersAction(data))
        return Promise.resolve(data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function fetchPathwaysByMembers(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/photoroute',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

export function mapCheckUserDetail(pathway, viewer) {
  // 查看地点信息窗中，点击【查看拍照路线详情】
  return (dispatch, getState) => {
    const state = getState().pathway
    const takeMembers = state.takeMembers
    const checkedMembers = state.checkedMembers

    const pathwayObj = pathway

    MapUtils.drawPathsV2({
      pathways: [pathwayObj],
      checkedMembers: checkedMembers,
      createInfoWindow: (pathIndexInMap, markerIndex) =>
        MapUtils.createLocationInfoWindowV2({
          pathway: pathwayObj,
          markerIndex,
          onButtonClick: null,
          onViewPhoto: (photoIndex) => {
            dispatch(viewPhoto(pathwayObj, markerIndex, photoIndex, viewer))
            sensors.track('web_pathway_homepage_click', {
              clickItem: 'routeNodePic',
              groupID: getState().main.groupId,
              locationName: pathwayObj.locations?.[markerIndex]?.texts?.addr,
              photoNum: pathwayObj.locations?.[markerIndex]?.photos?.length || 0
            })
          },
          canCheckDetail: false
        })
    })

    const foundMember = takeMembers.find(
      (member) => member.userID === pathwayObj.userID
    )
    dispatch(setCurrentUserAction(foundMember || null))
  }
}

export function viewPhoto(pathway, markerIndex, photoIndex, viewer) {
  return (dispatch, getState) => {
    const pathwayObj = pathway

    const photos = (pathwayObj.locations?.[markerIndex]?.photos || []).map((photo) => {
      // "吴超 2020-11-06 13:41:06.jpg"
      const saveName = `${pathwayObj.nickname} ${dayjs
        .unix(photo.time)
        .format(CONFIG.timeFormat)}.${
        photo.mediaType === 0
          ? photo.largeurl?.split('?')[0].split('.').pop()
          : photo.videoURL?.split('?')[0].split('.').pop()
      }`

      return {
        smallURL: photo.smallurl,
        largeURL: photo.largeurl,
        mediaType: photo.mediaType,
        saveName,
        videoURL: photo.videoURL,
        sourceType: photo.sourceType,
        seq: photo.photoID
      }
    })

    dispatch(setViewerPhotosAction(photos))
    viewer.view(photoIndex)
  }
}
